import { authStorage } from "@/services/authService";

/**
 * The key every offline record is filed under.
 *
 * Deliberately the username, not a display name: two people sharing a clinic
 * tablet must never read each other's packs, drafts or queued work.
 *
 * Its own module, tiny on purpose — the read path (`posDataSource`) needs the
 * user key but must not drag in the downloader, which reaches the API layer and
 * from there the router. Keeping this separate is what lets the read path be
 * tested, and loaded, on its own.
 */
export function currentUserKey(): string {
  try {
    // `authStorage` already resolves local-vs-session persistence, so this is the
    // same username the rest of the app authenticates as.
    return String(authStorage.getUsername() ?? "").trim();
  }
  catch {
    return "";
  }
}
